<template>
  <span>{{ getCataloguingLifecycleDisplayValue(inventory.cataloguing_lifecycle) }} </span>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers('global');


export default {
  name: "CataloguingLifecycleDisplayWidget",
  props: {
    inventory: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      cataloguingLifecycleOptions: state => state.cataloguingLifecycleOptions,
    }),
  },
  methods: {
    getCataloguingLifecycleDisplayValue(cataloguingLifecycle) {
      if (!cataloguingLifecycle || !this.cataloguingLifecycleOptions) {
        return cataloguingLifecycle;
      }
      const option = this.cataloguingLifecycleOptions.find(opt => opt.key === cataloguingLifecycle);
      return option ? option.value : cataloguingLifecycle;
    },
  }
}
</script>

<style scoped lang="scss">

</style>
